<template>
    <div class="print-page">
        <h2>基本信息</h2>
        <br/>
        <br/>
        <br/>
        <div class="d-block">
            <h3>儿童信息：</h3>
            <table border al="left" class="mt-sm">
                <tr>
                    <th width="100">姓名</th>
                    <th>{{ user.name }}</th>
                    <th width="100">编号</th>
                    <th>{{ user.serialNumber }}</th>
                </tr>
                <tr>
                    <td>性别</td>
                    <td>{{ $common.sex.find(e => e.value === user.sex).text }}</td>
                    <td>出生日期</td>
                    <td>{{ $moment(user.birthday).format('YYYY-MM-DD') }}</td>
                </tr>
                <tr>
                    <td>用户ID</td>
                    <td colspan="3">{{ user.hospitalId }}</td>
                </tr>                
                <tr>
                    <td>身份证号</td>
                    <td colspan="3">{{ user.idCard }}</td>
                </tr>
                <tr>
                    <td>家庭住址</td>
                    <td colspan="3">{{ user.regionName ? user.regionName.replace(/,/g, '') : '' }}</td>
                </tr>
            </table>
        </div>
        <br/>
        <br/>
        <div class="d-block" v-if="user.parents && user.parents[0] && user.parents[0].id">
            <h3>父亲信息：</h3>
            <table border al="left" class="mt-sm">
                <tr>
                    <th width="100">姓名</th>
                    <th>{{ user.parents[0].name }}</th>
                    <th width="100">联系电话</th>
                    <th>{{ user.parents[0].phone }}</th>
                    <th width="100">出生日期</th>
                    <th>{{ $moment(user.parents[0].birthday).format('YYYY-MM-DD') }}</th>
                </tr>
                <tr>
                    <td>文化程度</td>
                    <td colspan="5">{{ user.parents[0].education ? $common.education.find(e => e.value === user.parents[0].education).name : '' }}</td>
                </tr>
                <tr>
                    <td>职业</td>
                    <td colspan="5">{{ user.parents[0].occupation ? $common.occupation.find(e => e.value === user.parents[0].occupation).name : '' }}</td>
                </tr>
            </table>
        </div>
        <br/>
        <br/>
        <div class="d-block" v-if="user.parents && user.parents[1] && user.parents[1].id">
            <h3>母亲信息：</h3>
            <table border al="left" class="mt-sm">
                <tr>
                    <th width="100">姓名</th>
                    <th>{{ user.parents[1].name }}</th>
                    <th width="100">联系电话</th>
                    <th>{{ user.parents[0].phone }}</th>
                    <th width="100">出生日期</th>
                    <th>{{ $moment(user.parents[1].birthday).format('YYYY-MM-DD') }}</th>
                </tr>
                <tr>
                    <td>文化程度</td>
                    <td colspan="5">{{ user.parents[1].education ? $common.education.find(e => e.value === user.parents[1].education).name : '' }}</td>
                </tr>
                <tr>
                    <td>职业</td>
                    <td colspan="5">{{ user.parents[1].occupation ? $common.occupation.find(e => e.value === user.parents[1].occupation).name : '' }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            user: {},
        },
        data() {
            return {}
        },
        async beforeDestroy() {},
        async created() {
            console.log('基础信息---------->', this.user);
        },
        async mounted() {},
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/jichuxinxi.vue